// import React from 'react'
// import { IoIosArrowForward } from 'react-icons/io'
// import { Link } from 'react-router-dom'

const LibraryNavbar = ({sectionTitle, subsectionName}) => {
  return (
    // Removed pink background breadcrumb as requested
    null
  )
}

export default LibraryNavbar